export default __webpack_public_path__ + "static/media/CoordinadorDeArea.3fd54c89.png";